import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import CollapsibleFormElement from "../../common/collapsible-form-element";

type LaraStyleValue = "faithful" | "fluid" | "creative";

const styleOptions: {
  value: LaraStyleValue;
  label: string;
  description: string;
}[] = [
  {
    value: "faithful",
    label: "Faithful",
    description: "Maintains literal accuracy to the source text",
  },
  {
    value: "fluid",
    label: "Fluid",
    description: "Provides natural-sounding translations",
  },
  {
    value: "creative",
    label: "Creative",
    description: "Allows more interpretive renderings",
  },
];

export default function LaraStyle({
  style,
  setStyle,
}: {
  style: LaraStyleValue;
  setStyle: (style: LaraStyleValue) => void;
}) {
  return (
    <CollapsibleFormElement title="AI Translation Style">
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, display: "block" }}
      >
        Select the translation style to control how translations are rendered.
      </Typography>

      <Paper variant="outlined" sx={{ mt: 2 }}>
        <RadioGroup
          value={style}
          onChange={(e) => setStyle(e.target.value as LaraStyleValue)}
        >
          {styleOptions.map((option) => (
            <Box key={option.value} sx={{ ml: 2, my: 1 }}>
              <FormControlLabel
                value={option.value}
                control={<Radio size="small" />}
                label={
                  <Box>
                    <Typography variant="body2" fontWeight="medium">
                      {option.label}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {option.description}
                    </Typography>
                  </Box>
                }
                sx={{
                  alignItems: "flex-start",
                  "& .MuiRadio-root": { pt: 0 },
                }}
              />
            </Box>
          ))}
        </RadioGroup>
      </Paper>
    </CollapsibleFormElement>
  );
}
